/* eslint-disable react-refresh/only-export-components */

import { ReloadOutlined } from '@ant-design/icons';
import { useQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { Button, Form, Space, Spin, Typography } from 'antd';
import { useState } from 'react';
import { pseudoModels } from '../../features/common/model';
import {
  imageModelNameMap,
  type ImageModelCode,
} from '../../features/image/image-llm';
import { queryMyTaskStatistics } from '../../features/statistics/api';
import { ModelStatisticsTable } from '../../features/statistics/components/model-statistics-table';
import { TaskStatisticsCharts } from '../../features/statistics/components/task-statistics-charts';
import { TaskStatisticsSummary } from '../../features/statistics/components/task-statistics-summary';
import { TimeRangePicker } from '../../features/statistics/components/time-range-picker';
import { todayRange } from '../../features/statistics/constants';
import {
  videoModelNameMap,
  type VideoModelCode,
} from '../../features/video-model/model-spec';

function formatModelName(model: string) {
  return (
    videoModelNameMap.get(model as VideoModelCode) ??
    imageModelNameMap.get(model as ImageModelCode) ??
    pseudoModels.get(model) ??
    model
  );
}

export const Route = createFileRoute('/_creator-center/statistics')({
  component: Statistics,
});

function Statistics() {
  const [rangeType, setRangeType] = useState(todayRange);

  const {
    data: task_statistics,
    isFetching: is_task_fetching,
    refetch,
  } = useQuery(queryMyTaskStatistics(rangeType[0], rangeType[1]));

  return (
    <div className="h-full overflow-auto bg-white p-4">
      <div className="mb-4 flex flex-wrap items-center">
        <Typography.Title level={4} style={{ margin: 0 }}>
          我的数据统计
        </Typography.Title>
        <div className="flex-auto"></div>
        <Form layout="inline">
          <Form.Item className="!mr-0" label="统计时间">
            <TimeRangePicker value={rangeType} onChange={setRangeType} />
          </Form.Item>
          <Form.Item>
            <Button
              variant="filled"
              color="default"
              classNames={{ root: 'ml-2' }}
              icon={<ReloadOutlined />}
              onClick={() => refetch()}
            ></Button>
          </Form.Item>
        </Form>
      </div>
      <Spin spinning={is_task_fetching}>
        <Space className="w-full" orientation="vertical" size={16}>
          <TaskStatisticsSummary data={task_statistics} />

          <TaskStatisticsCharts
            accountStats={task_statistics?.account_stats ?? []}
            modelStats={task_statistics?.model_stats ?? []}
            departmentStats={task_statistics?.department_stats ?? []}
            mode="model-only"
            formatModelName={formatModelName}
          />

          <ModelStatisticsTable
            data={task_statistics?.model_stats ?? []}
            formatModelName={formatModelName}
          />
        </Space>
      </Spin>
    </div>
  );
}
